/*
 * mc-home-a.js — telemetria da home "Opção A · Prateleira Direta" (task 0036 · DP-12)
 *
 * Escopo: SÓ telemetria. Nenhum comportamento da home depende deste arquivo —
 * âncoras, sticky, carrossel scroll-snap e o add-to-cart (<product-form> nativo)
 * funcionam com o JS desligado (DP-13). Se este script falhar, nada quebra.
 *
 * Emitido com defer pelas sections instrumentadas (hero, quick-nav, campanha,
 * marca, par). Como <script src> duplicado EXECUTA de novo (diferente de <link>),
 * o guard abaixo é obrigatório — precedente mc-shelf.js (0029 F2 · D22).
 *
 * Listeners delegados no document (padrão mc-quick-add.js / mc-shelf.js): sobrevive
 * ao re-render de section do Theme Editor sem re-registrar nada.
 *
 * LGPD (DP-12): payload sem PII por construção. O destino é reduzido a
 * location.pathname — query string e hash são DESCARTADOS, então nenhum
 * parâmetro de formulário, CEP, e-mail ou token pode vazar por engano.
 */
(function () {
  'use strict';

  if (window.__mcHomeAInit) return;
  window.__mcHomeAInit = true;

  /* dataLayer pode não existir se o GTM/Google channel ainda não carregou. */
  function push(payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (e) {
      /* telemetria nunca derruba a página */
    }
  }

  /* Destino sem PII: só o caminho. Aceita URL absoluta, relativa e âncora. */
  function safePath(raw) {
    if (!raw) return '';
    var value = String(raw);
    if (value.charAt(0) === '#') return value.split('?')[0];
    try {
      return new URL(value, window.location.origin).pathname;
    } catch (e) {
      return value.split('?')[0].split('#')[0];
    }
  }

  function attr(el, name) {
    var v = el.getAttribute(name);
    return v == null ? '' : v;
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var el = target.closest('[data-mc-home-ev]');
      if (!el) return;

      var kind = attr(el, 'data-mc-home-ev');

      /* R-3 do review: hero e banner de marca são superfícies distintas — um
         evento só impediria o GA4 de separar as duas origens de add-to-cart. */
      if (kind === 'hero_atc' || kind === 'brand_atc') {
        push({
          event: kind === 'brand_atc' ? 'home_brand_atc' : 'home_hero_atc',
          product_id: attr(el, 'data-mc-ev-product-id'),
          product_handle: attr(el, 'data-mc-ev-handle')
        });
        return;
      }

      if (kind === 'quick_nav') {
        push({
          event: 'home_quick_nav_click',
          /* R-4 do review: mesma redução sem PII aplicada ao destino dos banners. */
          anchor: safePath(attr(el, 'data-mc-ev-anchor'))
        });
        return;
      }

      if (kind === 'banner') {
        push({
          event: 'home_banner_click',
          banner_type: attr(el, 'data-mc-ev-banner-type'),
          target: safePath(attr(el, 'data-mc-ev-target') || el.getAttribute('href'))
        });
        return;
      }

      if (kind === 'brand') {
        push({
          event: 'home_brand_click',
          vendor: attr(el, 'data-mc-ev-vendor')
        });
      }
    },
    /* passive: não interfere na navegação nem no submit do form nativo. */
    { passive: true }
  );
})();
